import { render, staticRenderFns } from "./CorporatePay.vue?vue&type=template&id=ff76559c&scoped=true"
import script from "./CorporatePay.vue?vue&type=script&setup=true&lang=js"
export * from "./CorporatePay.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CorporatePay.vue?vue&type=style&index=0&id=ff76559c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff76559c",
  null
  
)

export default component.exports